import React, { useState } from "react";
import { Button, Checkbox, Dropdown, Tooltip } from "antd";
import { truncateParagraph } from "../../../common/helper/truncateParagraph";

const HomeFilterDropdown = ({ title, options, onApply }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [open, setOpen] = useState(false);
  const isAllSelected = selectedItems.length === options.length;

  const handleSelectAll = (checked) => {
    setSelectedItems(checked ? options.map((o) => o.id) : []);
  };

  const handleCheckboxChange = (checked, id) => {
    setSelectedItems((prev) =>
      checked ? [...prev, id] : prev.filter((item) => item !== id)
    );
  };

  const handleReset = () =>{
    setSelectedItems([]);
    onApply([]);
    setOpen(false);
  } 

  const handleApply = () => {
    onApply(selectedItems);
    setOpen(false);
  };

  const dropdownContent = (
    <div
      style={{
        backgroundColor: "#fff",
        width: 250,
        borderRadius: 12,
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.27)",
        padding: '16px 12px 12px 16px',
      }}
    >
     {options?.length > 0 ? <div className="home-filter-checkbox">
      <Checkbox
        checked={isAllSelected}
        onChange={(e) => handleSelectAll(e.target.checked)}
        style={{
          marginBottom: 8,
          fontSize: "12px",
          display: "flex",
          gap: "16px",
        }}
        >
        Select All
      </Checkbox>
        </div> :
        <p style={{color:'#afafaf', fontWeight:'500', textAlign:'center',padding:'10px'}}>No data</p>
        }

      <div style={{ maxHeight: 200, overflowY: "auto" }}>
        {options.map((option) => (
          <div
            className="home-filter-checkbox"
            key={option.id}
            style={{ padding: "6px 0" }}
          >
            <Checkbox
              style={{ fontSize: "12px", display: "flex", gap: "16px" }}
              checked={selectedItems.includes(option.id)}
              onChange={(e) =>
                handleCheckboxChange(e.target.checked, option.id)
              }
            >
              <span style={{ color: "#000" }}>
                <Tooltip title={option.title || option.name || option?.courier_name}>
                  <span>
                {truncateParagraph(option.title || option.name || option?.courier_name, 15)}
                </span>
                </Tooltip>
              </span>
              <br />
              {option?.address && (
                <span style={{ color: "#5E5E5E" }}>
                  {truncateParagraph(option?.address, 17)}
                </span>
              )}
            </Checkbox>
          </div>
        ))}
      </div>
      {options?.length > 0 &&
      <div style={{ marginTop: 12, display: "flex", justifyContent: "end", gap:'8px' }}>
        <Button
          type="text"
          disabled={selectedItems.length === 0}
          onClick={handleReset}
          style={{
            borderRadius: "8px",
            fontWeight: 600,
            fontSize: "12px",
            height: "28px",
          }}
        >
          Reset
        </Button>
        <Button
          type="primary"
          disabled={selectedItems.length === 0}
          onClick={handleApply}
          style={{
            width: "58px",
            height: "28px",
            backgroundColor: selectedItems.length === 0 ? "#afafaf" : "#000",
            borderColor: selectedItems.length === 0 ? "#afafaf" : "#000",
            borderRadius: "8px",
            fontWeight: 600,
            fontSize: "12px",
          }}
        >
          Apply
        </Button>
      </div>
}

    </div>
  );

  return (
    <Dropdown
    open={open}
      onOpenChange={setOpen}
      overlay={dropdownContent}
      trigger={["click"]}
      placement="bottomLeft"
      overlayStyle={{ zIndex: 1000 }}
      className="home-filter-dropdown"
    >
      <Button
        style={{
          width: "fit-content",
          height: "28px",
          borderRadius: 20,
          fontWeight: 600,
          fontSize: 12,
          padding: "6px 8px",
          backgroundColor: open ? "#000" : "#f3f3f3",
          color: "#000",
          border: "0",
        }}
      >
       <span className={` ${open ? 'open' : 'home-pills-title-color'} `}> {title} </span>
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.295 4.14763L6 6.43763L3.705 4.14763L3 4.85263L6 7.85263L9 4.85263L8.295 4.14763Z"
            fill={open ? 'white' : "black"}
          />
        </svg>
      </Button>
    </Dropdown>
  );
};

export default HomeFilterDropdown;
